import { defaultTo, toLower, sortBy, pipe, prop } from "ramda";

export const standardizeName = pipe(
  prop("name"),
  defaultTo(""),
  toLower
);

export const sortByName = sortBy(standardizeName);
